import React from 'react';
import PropTypes from 'prop-types';

const NextArrow = (props) => {
  const {month, onClick} = props;
  return (
    <button
      className="calendar__month-item calendar__month-next "
      onClick={() => {
        onClick(month.index)
      }}
    >
      {month.name}
      <span className="button-main__icon ion-ios-arrow-forward not-font">i</span>
    </button>
  );
};

NextArrow.propTypes = {
  month: PropTypes.object,
  onClick: PropTypes.func,
};

const PrevArrow = (props) => {
  const {month, onClick} = props;
  return (
    <button
      className="calendar__month-item calendar__month-prev"
      onClick={() => {
        onClick(month.index)
      }}
    >
      <span className="button-main__icon ion-ios-arrow-back not-font">i</span>
      {month.name}
    </button>
  );
};

PrevArrow.propTypes = {
  month: PropTypes.object,
  onClick: PropTypes.func,
};

class MonthNaw extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      selectedMonth: null,
      next: null,
      prev: null,
    }
  }

  static propTypes = {
    monthList: PropTypes.array,
    selectedMonth: PropTypes.number,
    year: PropTypes.number,
    onNewMonth: PropTypes.func,
    onNewYear: PropTypes.func
  };

  componentWillMount() {
    this.setState({
      selectedMonth: this.props.selectedMonth,
      next: this.setNext(this.props.selectedMonth),
      prev: this.setPrev(this.props.selectedMonth),
    })
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      selectedMonth: nextProps.selectedMonth,
      next: this.setNext(nextProps.selectedMonth),
      prev: this.setPrev(nextProps.selectedMonth),
    })
  }

  setNext(month) {
    let result = month;
    if (month !== 11)
      result += 1;
    else {
      result = 0;
    }
    return result;
  }

  setPrev(month) {
    let result = month;
    if (month !== 0) {
      result -= 1;
    } else
      result = 11;
    return result;
  }

  onNext(month) {
    if (this.state.next === 0) {
      this.props.onNewYear(this.props.year + 1)
    }
    this.setState({
      selectedMonth: month,
      next: this.setNext(month),
      prev: this.setPrev(month),
    });
    this.props.onNewMonth(month);
  }

  onPrev(month) {
    if (this.state.prev === 11) {
      this.props.onNewYear(this.props.year - 1)
    }
    this.setState({
      selectedMonth: month,
      next: this.setNext(month),
      prev: this.setPrev(month),
    });
    this.props.onNewMonth(month);
  }

  render() {
    const {monthList} = this.props;
    const {next, prev} = this.state;

    return (
      <div className="calendar__month">
        <PrevArrow
          onClick={(e) => {
            this.onPrev(e)
          }}
          month={{name: monthList[prev], index: prev}}
        />

        <div className="calendar__month-item calendar__month-active">
          <span className="calendar__year">{this.props.year}</span>
          <span className="calendar__month-body">{monthList[this.state.selectedMonth]}</span>
        </div>

        <NextArrow
          onClick={(e) => {
            this.onNext(e)
          }}
          month={{name: monthList[next], index: next}}
        />
      </div>
    )
  }
}


export default MonthNaw;



// WEBPACK FOOTER //
// ./src/app/components/Calendar/Nav.js